import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const SidebarBody = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): ReactElement => (
  <div
    {...props}
    className={clsx(
      className,
      "flex flex-1 flex-col overflow-y-auto px-4 py-2 [&>[data-slot=section]+[data-slot=section]]:mt-8",
    )}
  />
);
